export const FEATURE_TAGS = {
  category: {
    common: '%%common%%',
  },
  question: {
    first: '%%first%%',
    announcement: '%%announcement%%',
  },
  answers: {
    others: /%%others%%|%%others\(\d+[a-z%]*\)%%/,
  }
}